export default {
  '320': '該当データがありません',
  '300': '入力内容を確認してください',
  '100': '再確認が必要な処理です',
  '310': '競合のため処理を行うことができませんでした',
  '400': 'エラーです',
  '404': '通信エラー(404)です',
  '500': 'システムエラーです',
  '800': '認証が無効になりました',
  '810': '要求された処理を行う権限がありません',
  '820': '認証が無効になりました',
  '999': '通信エラーです'
}



// WEBPACK FOOTER //
// ./src/lang/locales/ja/api.js